import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { sendGetRequest, sendPostRequest, sendPutRequest } from 'utils/Api';

export const unitsResponseData = createAsyncThunk('units/unitsResponseData', async (payload) => {
    try {
        let response;
        if (!payload) {
            response = await sendGetRequest(`/api/unit`)
        } else if (typeof payload === 'number') {
            response = await sendGetRequest(`/api/unit?page=${payload}`);
        } else if (typeof payload === 'object' && !payload.search && !payload.payload) {
            response = await sendGetRequest(`/api/unit?status=HOLD&project=${payload.project}&pagesize=1000`);
        } else {
            response = await sendGetRequest(`/api/unit?${payload.search}&page=${payload.pageNo}`);

        }
        return response.data;
    } catch (error) {
        throw Error(error.response.data.error); // Throw error if API call fails
    }

});

// Create a New Units
export const sendDataToUnits = (payload) => {
    return async (dispatch) => {
        try {
            const response = await sendPostRequest('/api/unit', payload);
            dispatch({ type: 'SEND_DATA_SUCCESS', payload: response.data });
        } catch (error) {
            dispatch({ type: 'SEND_DATA_FAILURE', error: error.message });
        }
    };
};
export const updateUnits = (payload) => {
    return async (dispatch) => {
        try {
            const response = await sendPutRequest('/api/unit', payload);
            dispatch({ type: 'SEND_DATA_SUCCESS', payload: response.data });
        } catch (error) {
            dispatch({ type: 'SEND_DATA_FAILURE', error: error.message });
        }
    };
};

const unitsSlice = createSlice({
    name: 'units',
    initialState: {
        data: [],
        loading: false,
        error: null,
        // isSuccess: ''
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(unitsResponseData.pending, (state) => {
                state.loading = true;
            })
            .addCase(unitsResponseData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.error = null;
            })
            .addCase(unitsResponseData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default unitsSlice.reducer;
